// @flow strict

import * as React from 'react';
import type { AddressType } from '../../../../internal/Address';
import mapMarker from '../../../../static/icons/map-marker.svg';
import appendScriptOnce from '../../../../internal/util/appendScriptOnce';
import mapStyles from './mapStyles';

declare var google: any;

type PropTypes = {|
  address: AddressType,
|};

const parseAddress = (address: AddressType): string => {
  return `${address.line1} ${address.line2 || ' '}, ${address.city}, ${address.state} ${
    address.postcode
  } ${address.country}`;
};

function initMap(address) {
  if (!google || !google.maps) return;

  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: parseAddress(address) }, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK) {
      const myOptions = {
        zoom: 15,
        center: results[0].geometry.location,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapStyles,
      };

      const map = new google.maps.Map(document.querySelector('#gMap'), myOptions);

      // eslint-disable-next-line no-unused-vars
      const marker = new google.maps.Marker({
        map,
        position: results[0].geometry.location,
        icon: mapMarker,
      });
    }
  });
}

const src =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyD2Dd_JL0oQ-5U8PZCUrFldkLH_hd0f0dI&callback=initMap';

export default (props: PropTypes) => {
  React.useEffect(() => {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      initMap(props.address);
    } else {
      appendScriptOnce({ src, id: 'GoogleMapScript' });
      window.initMap = initMap.bind(null, props.address);
    }

    return function cleanup() {
      window.initMap = null;
    };
  }, [props.address]);

  return <div id="gMap" style={{ width: '100%', height: '100%' }} />;
};
